import axios, { AxiosResponse } from "axios";
import {
	getRequest,
	postRequest
} from "@/Utils/Service/BackendService";
import {
	DismissBannnerFeedMessageRequest,
	UserData
} from "@/Contracts";
import omit from "lodash/omit";

const dismissBannerNotificationURL = "/v2/banners/dismiss";
const getBeamerPostURL = "https://api.getbeamer.com/v0/posts";

export const dismissBannerNotification = async (
	banner: DismissBannnerFeedMessageRequest
): Promise<any> => {
	try {
		const response: AxiosResponse<any> = await axios(
			postRequest(
				dismissBannerNotificationURL,
				banner,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getBeamerPost = async (userData: UserData): Promise<any> => {
	try {
		let url = `${getBeamerPostURL}?userId=${userData.id}&published=true&saveViews=false&userFirstName=${userData.name.first}&userLastName=${userData.name.last}&userEmail=${userData.email}`;
		if (process.env.REACT_APP_NODE_ENV !== "production")
			url = `${url}&filterByUserId=true`;

		const customHeaders = {
			"Beamer-Api-Key": process.env.REACT_APP_BEAMER_AUTH_KEY ?? ""
		};

		const requestConfig = getRequest(
			url,
			null,
			false,
			false,
			false,
			undefined,
			customHeaders
		);

		// Need to remove these default headers as they are not supported by Beamer's API.
		const modifiedHeaders = omit(requestConfig.headers, [
			"Pragma",
			"Cache-Control",
			"X-Forwarded-For"
		]);
		requestConfig.headers = modifiedHeaders;

		const response: AxiosResponse<any> = await axios(requestConfig);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
